import { render } from "./info-widget.vue?vue&type=template&id=d36f58f8&scoped=true"
import script from "./info-widget.vue?vue&type=script&lang=js"
export * from "./info-widget.vue?vue&type=script&lang=js"

import "./info-widget.vue?vue&type=style&index=0&id=d36f58f8&lang=scss&scoped=true"

import exportComponent from "D:\\Cater-Frontend\\cater\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d36f58f8"]])

export default __exports__